import autorizacaoPdfUrl from "../../assets/conhecer/autorizacao.pdf";

export const GUIDED_TOUR_SIGNUP_URL = "https://apps.neomodelos.com.br";

export const GUIDED_TOUR_CTA_LABEL = "Clique aqui para conhecer mais";

/** Bundled Autorização para Venda de Imóvel (src/assets/conhecer/autorizacao.pdf). */
export const GUIDED_TOUR_SAMPLE_PDF_URL = autorizacaoPdfUrl;
